const cities = [
  'Seattle', 'Everett', 'Bellevue', 'Kirkland',
  'Redmond', 'Bothell', 'Lynnwood', 'Marysville',
  'Shoreline', 'Edmonds', 'Renton', 'Tacoma',
];

export default function ServiceAreasSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="service-areas" className="bg-[#0D0D0D] border-y border-white/8 py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-10 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-semibold">Where We Work</span>
            <div className="w-10 h-px bg-[#D4AF37]"></div>
          </div>
          <h2
            className="text-4xl md:text-5xl font-black text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Event Production Services Across<br />
            <em className="text-[#D4AF37] not-italic">Seattle &amp; Puget Sound</em>
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto">
            Professional event production throughout the greater Seattle metropolitan area — from Tacoma to Marysville and everywhere in between.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-stretch">
          {/* Map */}
          <div className="lg:w-[58%] rounded-2xl overflow-hidden border border-white/8 min-h-[440px]">
            <iframe
              title="Bugsie Productions — Everett WA Service Area"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d171195.3!2d-122.2!3d47.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549aa6b0e7b5e3b1%3A0x1234567890abcdef!2sEverett%2C%20WA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg)', minHeight: '440px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* City list + info */}
          <div className="lg:w-[42%] flex flex-col justify-between gap-8">
            <div>
              <h3 className="text-white font-semibold text-sm tracking-widest uppercase mb-5 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-2-line text-[#D4AF37] text-sm"></i>
                </div>
                Service Locations
              </h3>
              <div className="grid grid-cols-2 gap-y-3 gap-x-4 mb-6">
                {cities.map(city => (
                  <div key={city} className="flex items-center gap-2 group cursor-default">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]/50 group-hover:bg-[#D4AF37] transition-colors duration-300 flex-shrink-0"></div>
                    <span className="text-gray-400 group-hover:text-gray-200 text-sm font-medium transition-colors duration-300">{city}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Info card */}
            <div className="bg-[#111111] border border-white/6 rounded-xl p-5">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-[#D4AF37] text-lg"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-0.5">Bugsie Productions</p>
                  <p className="text-gray-500 text-sm">PO Box 12397, Everett, WA 98206</p>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed pl-11">
                Don't see your city? We travel throughout Washington State for the right event.
              </p>
            </div>

            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
              className="inline-flex items-center justify-center gap-3 bg-[#D4AF37] hover:bg-[#c49d2a] text-black font-bold px-8 py-4 rounded-full text-sm tracking-widest uppercase transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Check Availability in Your Area
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
